<!-- <div class="container not-found-page">
  <div class="">
      <h1 class="not-found-title">404</h1>
      <p class="not-found-text">{{'Page not found' | translate}}</p>
      <div class="not-found-link__wrapper">
        <a
          routerLink="/"
          class="not-found-link"
        >
          {{'Back to main page' | translate}}
        </a>
      </div>
  </div>
</div> -->
<div class="background-white" style="padding: 0px;">
  <div class="contract-list-header" style="border-bottom: 1px solid var(--border-light);">
    <div class="d-flex w-100 text-center flex-column" style="gap: 5px;">
      <h1 class="h3sub">{{'Page not found' | translate}}</h1>
      <p class="body4 color-medium-gray">{{'Page not found2' | translate}}</p>
    </div>
    
    <!-- <a routerLink="/" class="btn btn-primary">{{'Back to main page' | translate}}</a> -->
  </div>
  <div class="padding d-flex justify-content-center flex-column align-items-center gap-30">
    <button class="btn btn-secondary" (click)="goToMainPage()">{{'Back to previous page' | translate}}</button>
    <img
      src="assets/img/not-found-page.png"
      [attr.alt]="'alt.pageNotFoundImage' | translate"
    >
  </div>
</div>
